import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { resetCategorias, setBusca } from '../../slices/filterSlice'
import { PublicacionSinDetalle } from '../reutilizables/publicacionSinDetalle/PublicacionSinDetalle'
import { buscarTodasOptimizado } from '../servicios/publicacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './CabeceraBuscador.module.css'

const BUSCADOR_DELAY_MS = 1000

const CabeceraBuscador = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { busca } = useSelector((state) => state.filters)
  const [results, setResults] = useState([])
  const [showResults, setShowResults] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const timeoutRef = useRef(null)
  const containerRef = useRef(null)

  const handleInput = (e) => {
    const value = e.target.value
    const idComprador = parseInt(localStorage.getItem('idUsuario'))
    setSearchValue(value)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    if (!value) {
      setResults([])
      setShowResults(false)
      return
    }
    timeoutRef.current = setTimeout(async () => {
      const { data } = await buscarTodasOptimizado(idComprador, 0, 0, value)
      setResults(data.length ? data : [`No hay resultados para ${value}`])
      setShowResults(true)
    }, BUSCADOR_DELAY_MS)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowResults(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  useEffect(() => {
    setSearchValue(busca)
  }, [busca])

  return (
    <div className={`${styles.buscadorBox} box`} ref={containerRef}>
      <div className="container-4">
        <form
          id="formCabeceraBuscador"
          onSubmit={(event) => {
            event.preventDefault()
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current)
              timeoutRef.current = null
            }
            setShowResults(false)
            setResults([])
            dispatch(resetCategorias())
            dispatch(setBusca(searchValue))
          }}
        >
          <input
            type="text"
            id="search"
            autoComplete="off"
            placeholder="Buscar publicaciones..."
            value={searchValue}
            onChange={(e) => handleInput(e)}
            onClick={() => searchValue && setShowResults(true)}
          />
          <LinkButton className="icon" type="submit">
            <i className="fa fa-search" aria-hidden="true" />
          </LinkButton>
        </form>
      </div>

      {showResults && results.length > 0 && (
        <div className={styles.buscadorResultados}>
          {results.map((publicacion) => (
            <div
              key={publicacion.idPublicacion || publicacion}
              className={styles.buscadorItem}
              onClick={() => {
                if (publicacion.idPublicacion) {
                  setShowResults(false)
                  setResults([])
                  setSearchValue('')
                  navigate(`/Publicacion/${publicacion.idPublicacion}`)
                }
              }}
            >
              {publicacion.idPublicacion ? (
                <PublicacionSinDetalle publicacion={publicacion} />
              ) : (
                <p>{publicacion}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CabeceraBuscador
